import { render, staticRenderFns } from "./AddColaboratorModalProjectDetail.vue?vue&type=template&id=64c44edb&scoped=true&"
import script from "./AddColaboratorModalProjectDetail.vue?vue&type=script&lang=js&"
export * from "./AddColaboratorModalProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddColaboratorModalProjectDetail.vue?vue&type=style&index=0&id=64c44edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c44edb",
  null
  
)

export default component.exports